/* PackageEditorInstallTabComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./PackageEditorInstallTabRenderer");

class PackageEditorInstallTabComponent extends EventEmitter {
    constructor(packageEditorComponent) {
        super();
        this._packageEditorComponent = packageEditorComponent;
        this._renderer = new Renderer(this);

        this._registerListeners();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._renderer = undefined;
            //TODO set all class members to undefined here
            resolve();
        });
        this.emit("Shutdown");
        return prom;
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START EDITOR TAB METHODS */
    /*******************************************/
    resizeContainer(width, height) {
        this.emit("ResizeContainer", width, height);
    }
    /*******************************************/
    /* END EDITOR TAB METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/
    installPackage(cb) {
        this._packageEditorComponent.installPackage(cb);
    }
    downloadLog(cb, contents, fileName) {
        this._packageEditorComponent.downloadLog(cb, contents, fileName);
    }
    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = PackageEditorInstallTabComponent;
